import { PlayerRef } from "@remotion/player";
import { getIcon } from "../../../../../../../../utils/get-icon";
import { ZoomSlider } from "../../zoom-slider";
import {
  ActionRowWrapper,
  Wrapper,
  InnerWrapper,
  TimeWrapper,
  TimeDisplay,
  PlayButton,
} from "./styled";

interface Props {
  formatTime: (totalSeconds: number) => string;
  getCurrentTimeInSeconds: () => number;
  getTotalDurationInSeconds: () => number;
  togglePlayPause: () => void;
  isPlaying: boolean;
}

const MobileView = ({
  getCurrentTimeInSeconds,
  getTotalDurationInSeconds,
  formatTime,
  togglePlayPause,
  isPlaying,
}: Props) => {
  return (
    <>
      <ActionRowWrapper>
        <Wrapper>
          <InnerWrapper>
            <TimeWrapper>
              <TimeDisplay active>
                {formatTime(getCurrentTimeInSeconds())}
              </TimeDisplay>
              <TimeDisplay active={false}>
                /{formatTime(getTotalDurationInSeconds())}
              </TimeDisplay>
            </TimeWrapper>
          </InnerWrapper>
        </Wrapper>
        <Wrapper>
          <PlayButton onClick={togglePlayPause}>
            {isPlaying ? getIcon("pause") : getIcon("play")}
          </PlayButton>
        </Wrapper>
        <Wrapper>
          <InnerWrapper>
            <ZoomSlider />
          </InnerWrapper>
        </Wrapper>
      </ActionRowWrapper>
    </>
  );
};

export default MobileView;
